import { enviarFormularios, getPacoteFormulariosByUUID, getPacoteFormulariosInstitutionByUUID } from 'api/forms/pacote_formularios.api';
import { create } from 'zustand';

interface IFormulario {
  uuid: string;
  status: number;
  name: string;
  formulario: string;
}

interface IFormulariosStore {
  formularios: IFormulario[];
  setFormularios: (formularios: IFormulario[]) => void;
  getFormulariosByUUID: (uuid: string) => Promise<void>;
  getFormulariosByInstitutionUUID: (uuid: string) => Promise<void>;
  enviarFormularios: (uuid: string) => Promise<boolean>;
}

export const useFormulariosStore = create<IFormulariosStore>((set, get) => ({
  formularios: [],
  setFormularios: (formularios) => set({ formularios }),
  getFormulariosByUUID: async (uuid: string) => {
    try {
      const resp = await getPacoteFormulariosByUUID(uuid);
      const institutionUUID = resp?.dados?.institution_uuid;
      if (!institutionUUID) {
        console.error('Sem institution_uuid no payload', resp);
        set({ formularios: [] });
        return;
      }
      await get().getFormulariosByInstitutionUUID(institutionUUID);
    } catch (e) {
      console.error('getFormulariosByUUID failed:', e);
      set({ formularios: [] });
    }
  },

  getFormulariosByInstitutionUUID: async (uuid: string) => {
    try {
      const resp = await getPacoteFormulariosInstitutionByUUID(uuid);
      const forms = resp?.dados?.formularios ?? [];
      set({ formularios: forms });
    } catch (e) {
      console.error('getFormulariosByInstitutionUUID failed:', e);
      set({ formularios: [] });
    }
  },

  enviarFormularios: async (uuid: string) => {
    const response = await enviarFormularios(uuid);
    if (response.Status === `OK`) {
      return true;
    } else {
      return false;
    }
  },
}));
